import * as React from "react";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import { useUser } from "../../hooks/useUser.jsx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MenuList from "@mui/material/MenuList";
import PersonIcon from "@mui/icons-material/Person";
import Box from "@mui/material/Box";
import colors from "../../theme/colors.jsx";

export const UserMenu = () => {
  const { user, isLogged, logout } = useUser();
  const navigate = useNavigate();

  const { t } = useTranslation();

  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    window.open(
      user.urL_ModificarDatos,
      "_blank"
    );
    setOpen(false);
  };
  const handleLogout = () => {
    setAnchorElUser(null);
    logout();
    navigate("/");
    setOpen(false);
  };
  const handleUnsubscribeService = () => {
    setAnchorElUser(null);
    window.open(user.urL_Baja, "_blank");
    setOpen(false);
};

  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const userSettings = [
    { text: t("nav.Modificar datos"), click: handleCloseUserMenu },
    { text: t("nav.Baja"), click: handleUnsubscribeService },
    { text: t("nav.Desconectarse"), click: handleLogout },
  ];

  return (
    <>
      {/* {!isLogged && (
        <Typography
          to="Identificarse"
          component={Link}
          sx={{
            color: "white",
            textDecoration: "none",
          }}
        >
          {t("nav.Identificarse").toLocaleUpperCase()}
        </Typography>
      )} */}
      {isLogged && (
        <Stack direction="row">
          <Box>
            <Button
              ref={anchorRef}
              id="composition-button"
              aria-controls={open ? "composition-menu" : undefined}
              aria-expanded={open ? "true" : undefined}
              aria-haspopup="true"
              onClick={handleToggle}
              variant="text"
              color="text"
            >
              <Stack
                direction="row"
                justifyContent="center"
                alignItems="center"
                spacing={1}
              >
                <PersonIcon sx={{color: colors.primary}} />
                <Typography variant="parrafoPrimary" lineHeight="1">{user.nombre}</Typography>
              </Stack>
            </Button>
          </Box>
          <Popper
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
          >
            {(
              { TransitionProps, placement } // Esto sirve para que el menú salga hacía bajo desde el botón
            ) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom-start" ? "left top" : "left bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                    >
                      {userSettings.map((setting) => (
                        <MenuItem key={setting.text} onClick={setting.click}>
                          <Typography color="primary" textAlign="center">
                            {setting.text}
                          </Typography>
                        </MenuItem>
                      ))}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </Stack>
      )}
    </>
  );
};
